import { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '@spotahome/ui-library/src/tenant/components/Modal';
import { useMediatorModalHandle } from '@spotahome/ui-library/src/tenant/components/utils/withModalHandle';
import { OPEN_FULL_SCREEN_PHOTO_LIST } from '@spotahome/ui-library/src/tenant/components/utils/constants';

import './FullScreenPhotoList.scss';
import FullScreenPhotoListContent from './FullScreenPhotoListContent';

const FullScreenPhotoList = ({
  photos = [],
  headerActions = [],
  onClose = () => {},
  onImageClick = null,
  listingId
}) => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_FULL_SCREEN_PHOTO_LIST
  });

  const handleRequestClose = useCallback(() => {
    handleModalClose();
    onClose();
  }, [handleModalClose, onClose]);

  const handleImageClick = useCallback(
    photo => {
      handleRequestClose();
      onImageClick?.(photo);
    },
    [handleRequestClose, onImageClick]
  );

  if (!isModalOpen) return null;

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleRequestClose}
      size="fullscreen"
      ariaHideApp={false}
      contentLabel="Full screen photo list"
      shouldCloseOnOverlayClick={false}
      className="full-screen-photo-list"
    >
      <FullScreenPhotoListContent
        photos={photos}
        headerActions={headerActions}
        onClose={handleRequestClose}
        onImageClick={handleImageClick}
        listingId={listingId}
      />
    </Modal>
  );
};

FullScreenPhotoList.propTypes = {
  photos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      caption: PropTypes.string.isRequired,
      verified: PropTypes.bool
    })
  ).isRequired,
  headerActions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      iconName: PropTypes.string
    })
  ),
  onClose: PropTypes.func,
  onImageClick: PropTypes.func.isRequired,
  listingId: PropTypes.string.isRequired
};

export default FullScreenPhotoList;
